<template>
    <svg
        width="24"
        height="24"
        viewBox="0 0 24 24"
        class="fill-current"
        xmlns="http://www.w3.org/2000/svg"
    >
        <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M6 4C4.93913 4 3.92172 4.42143 3.17157 5.17157C2.42143 5.92172 2 6.93913 2 8V16C2 17.0609 2.42143 18.0783 3.17157 18.8284C3.92172 19.5786 4.93913 20 6 20H18C19.0609 20 20.0783 19.5786 20.8284 18.8284C21.5786 18.0783 22 17.0609 22 16V8C22 6.93913 21.5786 5.92172 20.8284 5.17157C20.0783 4.42143 19.0609 4 18 4H6ZM4.58579 17.4142C4.21071 17.0391 4 16.5304 4 16V8C4 7.46957 4.21071 6.96086 4.58579 6.58579C4.96086 6.21071 5.46957 6 6 6H18C18.5304 6 19.0391 6.21071 19.4142 6.58579C19.7893 6.96086 20 7.46957 20 8V16C20 16.5304 19.7893 17.0391 19.4142 17.4142C19.0391 17.7893 18.5304 18 18 18H6C5.46957 18 4.96086 17.7893 4.58579 17.4142Z"
        />
        <path
            d="M11 18V15C10.1557 15 9 14 9 13C9.00015 12.5 9.00039 11 9.00009 10.5H9.5V8.75C9.5 8.33579 9.83579 8 10.25 8C10.6642 8 11 8.33579 11 8.75V10.5H13V8.75C13 8.33579 13.3358 8 13.75 8C14.1642 8 14.5 8.33579 14.5 8.75V10.5H14.9995C15 11 15 12.5 15 13C15 14 13.892 15 13 15V18H11Z"
        />
    </svg>
</template>
